import { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link, useNavigate, useParams, useLocation, NavLink } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import Multiselect from 'multiselect-react-dropdown';
import "react-data-table-component-extensions/dist/index.css";
import * as React from 'react';
import TableToExcel from '@linways/table-to-excel';
// @mui
import { styled, useTheme } from '@mui/material/styles';
import { Button, Typography, Container, Box, Grid, Modal } from '@mui/material';
import * as userActions from "../../actions/userActions";
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import '../common.scss';
import * as beatPlanActions from "../../actions/beatPlanActions";
import Loader from "../../components/Loader";
import AccessDenied from '../common/AccessDenied';

// sections
import {
    AppTasks,
    AppNewsUpdate,
    AppOrderTimeline,
    AppCurrentVisits,
    AppWebsiteVisits,
    AppTrafficBySite,
    AppWidgetSummary,
    AppCurrentSubject,
    AppConversionRates,
} from '../../sections/@dashboard/app';

// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
    maxWidth: 480,
    margin: 'auto',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------
const BeatPlanReportPage = (props) => {
    const theme = useTheme();
    const { id } = useParams();
    const location = useLocation();
    const { actions, usersData } = props;
    const { register, handleSubmit, formState: { errors }, setValue } = useForm();
    const navigate = useNavigate();

    const [addModulePermissionStatus, setAddModulePermissionStatus] = useState(false);
    const [editModulePermissionStatus, setEditModulePermissionStatus] = useState(false);
    const [userHasPermission, setUserHasPermission] = useState(true);
    const [permissions, setPermissions] = useState([]);
    const [userRoleType, setUserRoleType] = useState('User');
    const [loggeInUserID, setLoggeInUserID] = useState('');

    const [allLoggedinUserChild, setAllLoggedinUserChild] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [allBeatPlanReportData, setAllBeatPlanReportData] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');

    const [sendCrifOpenModal, setSendCrifOpenModal] = React.useState(false);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [preloaderStatus, setPreloaderStatus] = useState(false);

    const [open, setOpen] = useState(false);
    const [beatPlanReportClickOnCountData, setBeatPlanReportClickOnCountData] = useState([]);
    const [currentPage2, setCurrentPage2] = useState(1);

    useEffect(() => {
        // check user is logged-in or not
        const authToken = localStorage.getItem('authToken');
        if (authToken === null) {
            navigate('/login');
        }
    }, []);

    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.getUserModuleData(requestData);
        response.then((result) => {
            // console.log("Promise resolved -  lead list:", result);
            if (result.data.success === 1) {
                const permissionsData = result.data.data;
                const hasViewPermissions = permissionsData.find(permission => permission.module_name === 'Beat Plan Report')?.view_permission;
                setPermissions(permissionsData);
                setUserHasPermission(hasViewPermissions);

                if (Object.prototype.hasOwnProperty.call(result.data, 'user_info') && Object.prototype.hasOwnProperty.call(result.data.user_info[0], 'role_type') && result.data.user_info[0].role_type !== '') {
                    setUserRoleType(result.data.user_info[0].role_type);
                    // alert(result.data.user_info[0].role_type);
                    setLoggeInUserID(result.data.user_info[0].user_id);
                }
            }
        }).catch((error) => {
            // console.error("Promise rejected -  lead list:", error);
        });
    }, [setPermissions, setUserHasPermission, setUserRoleType, setLoggeInUserID]);

    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.getLoggedinUserChild(requestData, false);

        response.then((result) => {
            // console.log("Promise resolved -  lead Status data:", result); 
            if (result.data.success === 1) {
                const results = result.data.data.data;

                const extractedData = results.map(item => {
                    return { id: item.user_id, name: item.name };
                });
                const resultArr = Object.values(extractedData);
                setAllLoggedinUserChild(resultArr);
            }
        }).catch((error) => {
            //  console.error("Promise rejected -  source data :", error); 
        });
    }, [setAllLoggedinUserChild]);

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Function to format a date to DD-MM-YYYY
    const formatDateToDDMMYYYY = (dateInput) => {
        const dateFormatted = new Date(dateInput);
        const day = String(dateFormatted.getDate()).padStart(2, '0');
        const month = String(dateFormatted.getMonth() + 1).padStart(2, '0');
        const year = dateFormatted.getFullYear();
        return `${day}-${month}-${year}`;
    };

    useEffect(() => {
        // Get the current date
        const today = new Date();

        // Calculate the previous day
        const previousDay = new Date(today);
        previousDay.setDate(today.getDate() - 1);

        // Format the dates in YYYY-MM-DD format
        const previousDayFormatted = formatDate(previousDay);
        const todayFormatted = formatDate(today);
        // Set the initial values in the form without triggering validation
        setValue('start_date', todayFormatted);
        setValue('end_date', todayFormatted);

        setStartDate(todayFormatted);
        setEndDate(todayFormatted);

        setPreloaderStatus(true);

        const params = { 'start': '0', 'length': config.MAX_RECORDS, 'start_date': todayFormatted, 'end_date': todayFormatted };
        const requestData = encryptData(params);
        const response = actions.getBeaPlanReportData(requestData, false);
        response.then((result) => {
            // console.log("Promise resolved -  getBeaPlanReportData:", result);
            if (result.data.success === 1) {
                setPreloaderStatus(false);
                const results = result.data.data.beat_plan_report;
                const resultArr = Object.keys(results).map((key) => results[key]);
                const sortedResultArr = resultArr.sort((a, b) =>
                    a.assignedUserName.localeCompare(b.assignedUserName)
                );
                const resultArrObj = Object.values(sortedResultArr);
                setAllBeatPlanReportData(resultArrObj);
            } else {
                setPreloaderStatus(false);
                setAllBeatPlanReportData([]);
            }
        }).catch((error) => {
            setPreloaderStatus(false);
            // console.error("Promise rejected -  getBeaPlanReportData:", error);
        });

    }, [setAllBeatPlanReportData, setStartDate, setEndDate]);

    const onSubmit = (data) => {
        const params = {
            'start': '0',
            'length': config.MAX_RECORDS,
            'assign_to': selectedUsers,
            'start_date': data.start_date,
            'end_date': data.end_date,
        };

        setStartDate(data.start_date);
        setEndDate(data.end_date);

        setPreloaderStatus(true);

        const requestData = encryptData(params);
        const response = actions.getBeaPlanReportData(requestData, false);
        response.then((result) => {
            // console.log("Promise resolved -  lead list:", result);
            if (result.data.success === 1) {

                // console.log("result.data.data.beat_plan_report : ", result.data.data.beat_plan_report);

                setPreloaderStatus(false);
                const results = result.data.data.beat_plan_report;
                const resultArr = Object.keys(results).map((key) => results[key]);

                const sortedResultArr = resultArr.sort((a, b) =>
                    a.assignedUserName.localeCompare(b.assignedUserName)
                );
                const resultArrObj = Object.values(sortedResultArr);
                setAllBeatPlanReportData(resultArrObj);
            } else {
                setPreloaderStatus(false);
                setAllBeatPlanReportData([]);
            }
        }).catch((error) => {
            setPreloaderStatus(false);
            // console.error("Promise rejected -  lead list:", error);
        });
    };

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const handlePageChange2 = (newPage) => {
        setCurrentPage2(newPage);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(1); // Reset to the first page when searching
    };

    const filteredItems = allBeatPlanReportData.filter(item => {
        const name = item.name?.toLowerCase() || '';
        const createdByName = item.createdByName?.toLowerCase() || '';
        const statusName = item.statusName?.toLowerCase() || '';

        return (
            name.includes(searchQuery.toLowerCase()) ||
            createdByName.includes(searchQuery.toLowerCase()) ||
            statusName.includes(searchQuery.toLowerCase())
        );
    });

    const startIndex = (currentPage - 1) * config.HUNDREAD_PER_PAGE;
    const endIndex = startIndex + config.HUNDREAD_PER_PAGE;
    const paginatedItems = filteredItems.slice(startIndex, endIndex);
    const totalPages = Math.ceil(filteredItems.length / config.HUNDREAD_PER_PAGE);

    const checkLogout = () => {
        const authToken = localStorage.getItem('authToken');
        const logInTimestamp = localStorage.getItem('logInTimestamp');

        if (logInTimestamp !== null) {
            const loginTimestamp = parseInt(logInTimestamp, 10);
            const currentTime = Math.floor(Date.now() / 1000);
            const timeElapsed = currentTime - loginTimestamp;
            const autoLogoutTimeInSecod = config.AUTO_LOGOUT_TIME_IN_SECONDS;

            if (timeElapsed >= autoLogoutTimeInSecod) {
                const params = { 'login_token': authToken };
                console.log("params : ", params);
                const requestData = encryptData(params);
                const response = actions.userLogout(requestData);
                response.then((result) => {
                    if (result.data.success === 1) {
                        const data = {};
                        actions.loadUserAuth(false);
                        actions.loginDataSuccess(data);
                        localStorage.setItem("authToken", '');
                        localStorage.setItem("logInTimestamp", '');
                        navigate("/login");
                    }
                }).catch((error) => {
                    console.log(error);
                });
            }
        }
    }

    const exportBeatPlanReport = async () => {
        const table = document.getElementById('exportBeatPlanReportExcelFile');

        TableToExcel.convert(table, {
            name: 'Beat-Plan-Report.xlsx',
            sheet: {
                name: 'Beat-Plan-Report',
            },
        });
    };

    useEffect(() => {
        checkLogout();
    });

    // The handleClick function can be defined to perform the desired action, such as showing a list.
    const handleClickOnCount = (assignedUserId, field) => {
        // console.log("Clicked data: ", assignedUserId);
        // console.log("Clicked field: ", field);
        // console.log("Clicked startDate: ", startDate);
        // console.log("Clicked endDate: ", endDate);

        const clickOnCountparams = {
            'start': '0',
            'length': config.MAX_RECORDS,
            'field': field,
            'assign_to': assignedUserId,
            'start_date': startDate,
            'end_date': endDate,
        };

        const requestData = encryptData(clickOnCountparams);
        const response = actions.getBeatPlanReportClickOnCount(requestData, false);
        response.then((result) => {
            // console.log("Promise resolved -  lead list:", result);
            if (result.data.success === 1) {
                setPreloaderStatus(false);
                const results = result.data.data.beat_plan_report;
                const resultArr = Object.keys(results).map((key) => results[key]);

                const sortedResultArr = resultArr.sort((a, b) =>
                    a.assignedUserName.localeCompare(b.assignedUserName)
                );
                const resultArrObj = Object.values(sortedResultArr);
                setBeatPlanReportClickOnCountData(resultArrObj);
                setOpen(true);
            } else {
                setPreloaderStatus(false);
                setBeatPlanReportClickOnCountData([]);
            }
        }).catch((error) => {
            setPreloaderStatus(false);
            // console.error("Promise rejected -  lead list:", error);
        });
    };

    const filteredItems2 = beatPlanReportClickOnCountData.filter(item => {
        const name = item.name?.toLowerCase() || '';
        const createdByName = item.createdByName?.toLowerCase() || '';
        const statusName = item.statusName?.toLowerCase() || '';

        return (
            name.includes(searchQuery.toLowerCase()) ||
            createdByName.includes(searchQuery.toLowerCase()) ||
            statusName.includes(searchQuery.toLowerCase())
        );
    });

    const startIndex2 = (currentPage2 - 1) * config.HUNDREAD_PER_PAGE;
    const endIndex2 = startIndex2 + config.HUNDREAD_PER_PAGE;
    const paginatedItems2 = filteredItems2.slice(startIndex2, endIndex2);
    const totalPages2 = Math.ceil(filteredItems2.length / config.HUNDREAD_PER_PAGE);

    const backToChecklistsHandler = () => {
        setOpen(false);
    }

    if (!userHasPermission) {
        // Redirect or render an access denied message
        return <AccessDenied />;
    }

    return (
        <>
            <Helmet>
                <title>Beat Plan Report</title>
            </Helmet>

            <Container>


                <form onSubmit={handleSubmit(onSubmit)}>
                    <div id='main-wrap' className={!open ? "mb-4 filter" : " mb-4 filter hide"}>
                        <div className='row mx-0'>
                            <div className='col'>
                                <div className='form-group'>
                                    <span>User</span>
                                    <div className="text-dark">
                                        <Multiselect
                                            id="created_by"
                                            options={allLoggedinUserChild.map((option) => ({
                                                key: option.id,
                                                value: option.name,
                                            }))}
                                            displayValue="value"
                                            onSelect={(selectedItems) => {
                                                const selectedValues = selectedItems.map(item => item.key);
                                                setSelectedUsers(selectedValues);
                                            }}
                                            onRemove={(selectedItems) => {
                                                const selectedValues = selectedItems.map(item => item.key);
                                                setSelectedUsers(selectedValues);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='col'>
                                <div className='form-group'>
                                    <label htmlFor="start-date">
                                        <span>Select Start Date</span>
                                        <input type='date' name='start_date' className='form-control'{...register('start_date', { required: true })} />
                                    </label>
                                    {errors.start_date && <span className="required">This field is required.</span>}
                                </div>
                            </div>
                            <div className='col'>
                                <div className='form-group'>
                                    <label htmlFor="end-date">
                                        <span>Select End Date</span>
                                        <input type='date' name='end_date' className='form-control'{...register('end_date', { required: true })} />
                                    </label>
                                    {errors.end_date && <span className="required">This field is required.</span>}
                                </div>
                            </div>
                            <div className='col'>
                                <div className='form-group mb-2'>
                                    <span className='d-block'>&nbsp;</span>
                                    <button className='btn btn-primary'>Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

                <div id='main-wrap' className={!open ? "mb-4" : " mb-4 hide"}>

                    <div className="row justify-content-between">
                        <div className="col-md-7">
                            <Typography className="line-initial" variant="h4" sx={{ mb: 0 }}>
                                Beat Plan Report
                            </Typography>
                        </div>

                        <div className='col-md-5 text-end ps-lg-5'>
                            <div className="form-group d-flex justify-content-end align-items-center">
                                <button className="btn btn-info text-white ms-3" onClick={() => exportBeatPlanReport()}>
                                    Export
                                </button>
                            </div>
                        </div>

                        <div className="col-md-12 mb-3">
                            Data from <b>{formatDateToDDMMYYYY(startDate)}</b> to <b>{formatDateToDDMMYYYY(endDate)}</b>
                        </div>
                    </div>

                    <div className='table-wrap table-responsive'>
                        <table className="table table-hover" id="exportBeatPlanReportExcelFile">
                            <thead>
                                {/* <tr>
                                    <td colSpan={6} className='d-none'>Data from <b>{formatDateToDDMMYYYY(startDate)}</b> to <b>{formatDateToDDMMYYYY(endDate)}</b></td>
                                </tr> */}
                                <tr>
                                    {/* <th className='text-nowrap'>Date</th> */}
                                    <th className='text-nowrap'>Name</th>
                                    <th className='text-nowrap'># of Beat Plans</th>
                                    <th className='text-nowrap'># of Beat Plans started On Time & Before Time</th>
                                    <th className='text-nowrap'># of Beat Plans Started After Time</th>
                                    <th className='text-nowrap'># of Beat Plans Missed</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedItems.map((item, index) => (
                                    <tr key={index}>
                                        <td className='text-nowrap'>{item.assignedUserName}</td>
                                        <td>
                                            <button onClick={() => handleClickOnCount(item.assigned_user, "noOfBeatPlans")} className="btn btn-link p-0 custom-button">{item.noOfBeatPlans}</button>
                                        </td>
                                        <td>
                                            <button onClick={() => handleClickOnCount(item.assigned_user, "noOfBeatPlansStartedOnTimeAndBeforeTime")} className="btn btn-link p-0 custom-button">{item.noOfBeatPlansStartedOnTimeAndBeforeTime}</button>
                                        </td>
                                        <td>
                                            <button onClick={() => handleClickOnCount(item.assigned_user, "noOfBeatPlansStartedAfterTime")} className="btn btn-link p-0 custom-button">{item.noOfBeatPlansStartedAfterTime}</button>
                                        </td>
                                        <td>
                                            <button onClick={() => handleClickOnCount(item.assigned_user, "noOfBeatPlansMissed")} className="btn btn-link p-0 custom-button">{item.noOfBeatPlansMissed}</button>
                                        </td>
                                    </tr>
                                ))}

                                {paginatedItems.length < 1 && (
                                    <>
                                        <tr>
                                            <td colSpan={7} className='text-center py-3 fw-bold'>No record found</td>
                                        </tr>
                                    </>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <nav className='mb-1'>
                            <ul className="pagination pagination-md justify-content-end">
                                {Array.from({ length: totalPages }, (_, index) => index + 1).map(page => (
                                    <li className="page-item">
                                        <button
                                            key={page}
                                            onClick={() => handlePageChange(page)}
                                            disabled={currentPage2 === page}
                                            className="page-link"
                                        >
                                            {page}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    </div>
                </div>

                <div id='main-wrap' className={open ? "mb-4" : " mb-4 hide"}>

                    <div className="row justify-content-between">
                        <div className="col-md-10">
                            <Typography className="line-initial" variant="h4" sx={{ mb: 0 }}>
                                Beat Plans
                            </Typography>
                        </div>

                        <div className='col-md-2 text-end ps-lg-2'>
                            <div className='d-flex flex-md-row flex-column align-md-items-center align-items-start justify-content-between'>
                                <button onClick={backToChecklistsHandler} onKeyDown={backToChecklistsHandler} className='btn fw-bold mb-3 bg-info text-white py-1 px-2 rounded order-md-2 order-1'> Back to Report</button>
                            </div>
                        </div>
                    </div>
                    <div className="table-wrap table-responsive">
                        <table className="table table-hover" id="exportBeatPlanExcelFile">
                            <thead>
                                <tr>
                                
                                    <th className="text-nowrap">User Name</th>
                                    <th className="text-nowrap">Scheduled Time</th>
                                    <th className="text-nowrap">Company Name</th>
                                    <th className="text-nowrap">Contact Name</th>
                                    <th className="text-nowrap">Phone Number</th>
                                    <th className="text-nowrap">Address</th>
                                    <th className="text-nowrap">Remark</th>
                                    <th className="text-nowrap">Visit Type</th>
                                    <th className="text-nowrap">Created On</th>
                                    <th className="text-nowrap">Created By</th>
                                </tr>
                            </thead>

                            <tbody>
                                {paginatedItems2.map((item, index) => (
                                    <tr key={index}>
                                        <td className="text-nowrap">{item.assignedUser}</td>
                                        <td>{item.scheduledTime}</td>
                                        <td>{item.companyName}</td>
                                        <td>{item.contact_name}</td>
                                        <td>{item.mobile}</td>
                                        <td>
                                            <p className='beat-plan-address'>{item.address}</p>
                                        </td>
                                        <td>
                                            <p className='beat-plan-remark'>{item.remarks}</p>
                                        </td>
                                        <td>{item.visitTypeName}</td>
                                        <td>{item.created_date}</td>
                                        <td>{item.createdByName}</td>
                                    </tr>
                                ))}

                                {paginatedItems.length < 1 && (
                                    <>
                                        <tr>
                                            <td colSpan={11} className='text-center py-3 fw-bold'>No record found</td>
                                        </tr>
                                    </>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <nav className='mb-1'>
                        <ul className="pagination pagination-md justify-content-end">
                            {Array.from({ length: totalPages }, (_, index) => index + 1).map(page => (
                                <li className="page-item">
                                    <button
                                        key={page}
                                        onClick={() => handlePageChange2(page)}
                                        disabled={currentPage === page}
                                        className="page-link"
                                    >
                                        {page}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    
                </div>

                {preloaderStatus && <Loader />}
            </Container>
        </>
    );
}

function mapStateToProps(state) {
    return {
        getBeaPlanReportData: state.getBeaPlanReportData,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign(beatPlanActions.default, userActions.default), dispatch),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(BeatPlanReportPage);